import FormFieldCheck from "@/store/Form/requestFormFieldCheck";

function fioStr(str,short = false) {
  if(typeof str === 'string') {
    return short? str[0]+'.':str;
  }
  return '';
}

const defaultData = () => {
  return {
    staffList: [],
    employeeList: [],
    /**
     * ниже два объекта, для раздела общих данных для добавления нового сотрудника.
     */
    newEmployeeData: {
      general: {
        organisationID: 0,
        staffName: '',
        staffSecondName: '',
        hasNotSecondName: false,
        staffLastName: '',
        staffDtBirth: '',
        staffGender: '',
        phonePersonal: ''

      },
    },
    newEmployeeWorkData: {
      general: {
        organisationID: { code: 1, msg: 'обязательное поле', ShowError: false },
        staffName: { code: 1, msg: 'обязательное поле', ShowError: false },
        staffSecondName: { code: 1, msg: 'обязательное поле', ShowError: false },
        staffLastName: { code: 1, msg: 'обязательное поле', ShowError: false },
        staffDtBirth: { code: 1, msg: 'обязательное поле', ShowError: false },
        staffGender: { code: 1, msg: 'обязательное поле', ShowError: false },
        phonePersonal: { code: 1, msg: 'обязательное поле', ShowError: false },
      },
    },

  }
};

const state = defaultData();

const getters = {
  getShortName:(state) => (staffId) =>{
    if (parseInt(staffId, 10) > 0) {
      let fnd = state.staffList.find((item)=>parseInt(item.staffId, 10) === staffId);
      return fnd!== undefined ?
        fioStr(fnd.lastName) + ' ' + fioStr(fnd.firstName, true) + ' ' + fioStr(fnd.secondName, true) : '';
    } else {
      return '';
    }
  },
};

const actions = {
  addList: ({commit}, newLsit) => {
    if (Array.isArray(newLsit) && newLsit.length > 0) {
      commit('insertList', newLsit);
    }
  },
  checkInputData: ({commit}, inputData) => {
    console.log('check')
    console.log(inputData.target)
    console.log(inputData.value)
    let fieldStatusEmployee = {};

    /**
     * сохраним данные в хранилище. Если ошибки будут, то они не позволят отправить данные из хранилища на бек
     */
    commit('errorObjAddToEmployeeData', {
      chapter: inputData.chapter,
      target: inputData.target,
      value: inputData.value
    })

    /**
     * смотрим по конкретным полям, что проверять и насколько они обязательны
     */

    switch (inputData.target) {
      case 'organisationID': {
        fieldStatusEmployee = FormFieldCheck.isEmptySelector(inputData.value);
      } break;
      case 'staffName': {
        fieldStatusEmployee = FormFieldCheck.isEmpty(inputData.value);
      } break;
      case 'staffLastName': {
        fieldStatusEmployee = FormFieldCheck.isEmpty(inputData.value);
      } break;
      case 'hasNotSecondName': {
        if (inputData.value) {
          commit('errorObjAddToEmployeeWorkData', {
            chapter: inputData.chapter,
            target: 'staffSecondName',
            errObj: { code: 0, msg: '', ShowError: false }
          });
        } else {
          commit('errorObjAddToEmployeeWorkData', {
            chapter: inputData.chapter,
            target: 'staffSecondName',
            errObj: { code: 1, msg: 'обязательное поле', ShowError: false },
          });
        }
      } break;
      case 'staffSecondName': {
        fieldStatusEmployee = FormFieldCheck.isEmpty(inputData.value);
      } break;
      case 'staffDtBirth': {
        fieldStatusEmployee = inputData.value.length === 0 ? FormFieldCheck.isEmpty(inputData.value) : FormFieldCheck.BIRTHDAY(inputData.value);
      } break;
      case 'phonePersonal': {
        fieldStatusEmployee = FormFieldCheck.isEmpty(inputData.value);
        commit('errorObjAddToEmployeeData', {
          chapter: inputData.chapter,
          target: inputData.target,
          value: FormFieldCheck.telToApi(inputData.value)
        })
      } break;
      case 'staffGender': {
        fieldStatusEmployee = FormFieldCheck.isEmpty(inputData.value);
      } break;
      default: break
    }

    /**
     * сохраняем объект ошибки, если таковой имеется
     */

    commit('errorObjAddToEmployeeWorkData', {
      chapter: inputData.chapter,
      target: inputData.target,
      errObj: fieldStatusEmployee
    });
  },
};

const mutations = {
  insertList: (state, newList) => state.staffList = newList,
  saveEmployeeList: (state, newList) => state.employeeList = newList,
  errorObjAddToEmployeeData: (state, valueObj) => state.newEmployeeData[valueObj.chapter][valueObj.target] = valueObj.value,
  errorObjAddToEmployeeWorkData: (state, valueObj) => state.newEmployeeWorkData[valueObj.chapter][valueObj.target] = valueObj.errObj,
  showErrors: (state, valueObj) => state.newEmployeeWorkData[valueObj.chapter][valueObj.target].ShowError = true,
  resetState: (state) => Object.assign(state, defaultData()),
};

export default {
  state,
  getters,
  actions,
  mutations,
}
